"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DraggableSongProps = void 0;

var _vue = require("vue");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var draggableSongProps = {
  distanceRight: {
    type: Number,
    default: 0
  },
  distanceBottom: {
    type: Number,
    default: 100
  },
  isScrollHidden: {
    type: Boolean,
    default: false
  },
  isCanDraggable: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: Number,
    default: 50
  },
  fitScreen: {
    type: Boolean,
    default: false
  },
  draggableEl: {
    type: HTMLDivElement
  }
};
exports.DraggableSongProps = draggableSongProps;
var Draggable = (0, _vue.defineComponent)({
  name: 'draggable',
  props: draggableSongProps,
  setup: function setup(props) {
    var _this = this;

    var clientWidth = (0, _vue.ref)(document.documentElement.clientWidth);
    var clientHeight = (0, _vue.ref)(document.documentElement.clientHeight);
    var floatDragDom = (0, _vue.ref)();
    var left = (0, _vue.ref)(0);
    var top = (0, _vue.ref)(0);
    var timer = (0, _vue.ref)(null);
    var currentTop = (0, _vue.ref)(0);
    var x = (0, _vue.ref)(0);
    var y = (0, _vue.ref)(0);
    var canClick = (0, _vue.ref)(true);
    var floatDragRef = (0, _vue.ref)();

    var init = function init() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!props.isCanDraggable) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return reset();

              case 3:
                props.isScrollHidden && window.addEventListener('scroll', handleScroll);
                window.addEventListener('resize', handleResize);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    var reset = function reset() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!props.isCanDraggable) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return (0, _vue.nextTick)();

              case 3:
                floatDragDom.value = floatDragRef.value.getBoundingClientRect();
                left.value = clientWidth.value - floatDragDom.value.width - props.distanceRight;
                top.value = clientHeight.value - floatDragDom.value.height - props.distanceBottom;
                initDraggable();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };

    var handleScroll = function handleScroll() {
      timer.value && clearTimeout(timer.value);
      timer.value = setTimeout(handleScrollEnd, 200);
      currentTop.value = document.documentElement.scrollTop || document.body.scrollTop;

      if (left.value > clientWidth.value / 2) {
        // 判断元素位置再左侧还是右侧
        left.value = clientWidth.value + floatDragDom.value.width;
      } else {
        left.value = -floatDragDom.value.width;
      }
    };

    var handleScrollEnd = function handleScrollEnd() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop === currentTop.value) {
        if (left.value > clientWidth.value / 2) {
          // 判断元素位置再左侧还是右侧
          left.value = clientWidth.value - floatDragDom.value.width;
        } else {
          left.value = 0;
        }

        clearTimeout(timer.value);
      }
    };

    var handleResize = function handleResize() {
      clientWidth.value = document.documentElement.clientWidth;
      clientHeight.value = document.documentElement.clientHeight;
      checkDraggablePosition();
    };

    var initDraggable = function initDraggable() {
      var el = floatDragRef.value;

      if (props.draggableEl) {
        el = props.draggableEl;
      }

      el.addEventListener('touchstart', function (e) {
        return toucheStart(e);
      });
      el.addEventListener('touchmove', function (e) {
        return touchMove(e);
      });
      el.addEventListener('touchend', touchEnd);
      el.addEventListener('mouseup', mouseUp);
      el.addEventListener('mousedown', mouseDown);
    };

    var mouseDown = function mouseDown(e) {
      var event = e || window.event;

      if (event.preventDefault) {
        event.preventDefault();
      }

      x.value = e.clientX;
      y.value = e.clientY;
      canClick.value = false;
      floatDragRef.value.style.transition = 'none';

      document.onmousemove = function (e) {
        var event = e || window.event;
        var leftOffset = event.clientX - x.value;
        var topOffset = event.clientY - y.value;
        var isLeft = leftOffset < 0;
        var isTop = topOffset < 0;
        isLeft ? left.value -= Math.abs(leftOffset) : left.value += Math.abs(leftOffset);
        isTop ? top.value -= Math.abs(topOffset) : top.value += Math.abs(topOffset);
        x.value = event.clientX;
        y.value = event.clientY;
      };
    };

    var mouseUp = function mouseUp() {
      document.onmousemove = null;
      checkDraggablePosition();
      floatDragRef.value.style.transition = 'all 0.1s';
    };

    var toucheStart = function toucheStart(e) {
      canClick.value = false; // floatDragRef.value.style.transition = 'none'

      if (e.targetTouches.length === 1) {
        // 单指点击
        var touch = e.targetTouches[0];
        x.value = touch.clientX;
        y.value = touch.clientY;
      }
    };

    var touchMove = function touchMove(e) {
      canClick.value = false;

      if (e.targetTouches.length === 1) {
        // 单指拖动
        var touch = e.targetTouches[0]; // left = touch.clientX - floatDragDom.width / 2
        // top = touch.clientY - floatDragDom.height / 2

        var leftOffset = touch.clientX - x.value;
        var topOffset = touch.clientY - y.value;
        var isLeft = leftOffset < 0;
        var isTop = topOffset < 0;
        isLeft ? left.value -= Math.abs(leftOffset) : left.value += Math.abs(leftOffset);
        isTop ? top.value -= Math.abs(topOffset) : top.value += Math.abs(topOffset);
        x.value = touch.clientX;
        y.value = touch.clientY;
      }
    };

    var touchEnd = function touchEnd() {
      if (!canClick.value) return; // 解决点击事件和touch事件冲突的问题

      floatDragRef.value.style.transition = 'all 0.1s';
      checkDraggablePosition();
    };

    var checkDraggablePosition = function checkDraggablePosition() {
      if (top.value < 0) {
        // 判断是否超出屏幕上沿
        top.value = 0;
      }

      if (top.value + floatDragDom.value.height >= clientHeight.value) {
        // 判断是否超出屏幕下沿
        top.value = clientHeight.value - floatDragDom.value.height - props.distanceBottom;
      }

      if (left.value < 0) {
        left.value = 0;
      }

      if (left.value + floatDragDom.value.width >= clientWidth.value) {
        left.value = clientWidth.value - floatDragDom.value.width - props.distanceRight;
      }

      if (props.fitScreen) {
        if (left.value + floatDragDom.value.width / 2 >= clientWidth.value / 2) {
          // 判断位置是往左往右滑动
          left.value = clientWidth.value - floatDragDom.value.width;
        } else {
          left.value = 0;
        }
      }
    };

    (0, _vue.onMounted)(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return init();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    });
    (0, _vue.onBeforeUnmount)(function () {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    });
    return {
      left: left,
      top: top,
      floatDragRef: floatDragRef,
      reset: reset
    };
  },
  render: function render() {
    return (0, _vue.createVNode)("div", {
      "ref": "floatDragRef",
      "class": "float-position",
      "style": {
        left: "".concat(this.left, "px"),
        top: "".concat(this.top, "px"),
        zIndex: this.zIndex
      },
      "onTouchmove": function onTouchmove(e) {
        return e.preventDefault();
      },
      "onMousemove": function onMousemove(e) {
        return e.preventDefault;
      }
    }, {
      default: this.$slots.default
    });
  }
});

Draggable.install = function (app) {
  app.component(Draggable.name, Draggable);
  return app;
};

var _default = Draggable;
exports.default = _default;